import React from "react";

import { ExportableNote } from "./components/ExportableNote";

export function NoteList({ notes, onToggleNote, onViewNote, selectedNoteIds }) {
  return (
    <ul className="tw:flex tw:flex-col tw:gap-5">
      {notes?.map((note) => (
        <ExportableNote
          isSelectedForExport={selectedNoteIds.has(note.id)}
          key={note.id}
          note={note}
          onToggleSelection={() => onToggleNote(note.id)}
          onView={() => onViewNote(note)}
        />
      ))}
    </ul>
  );
}
